<template>
    <div>
        <div id="place-details" v-if="!user.global_admin">
            <h1>{{ t('places-details-access_denied') }}</h1>
        </div>
        <div id="place-details" v-if="user.global_admin">
            <loader v-if="!is('ready')"></loader>
            <div class="container-fluid" v-if="is('ready')">
                <div class="top">
                    <div class="title">
                        <img
                            :src="logo"
                            @error="$root.errorImage"
                            height="50"
                        />
                        <h1>{{ name }}</h1>
                    </div>
                    <div>
                        <button class="btn btn-primary" @click="logAsPlace()">
                            {{ t('places-details-view_as', { name: name }) }}
                        </button>
                        <router-link
                            class="btn btn-primary"
                            :to="'/place/form/' + id"
                            >{{ t('places-details-edit_info') }}</router-link
                        >
                        <router-link
                            class="btn btn-primary"
                            :to="'/place/' + id + '/plan'"
                            >{{ t('places-details-manage_plan') }}</router-link
                        >
                        <button
                            :disabled="loading"
                            v-if="active"
                            class="btn btn-danger"
                            @click="block()"
                        >
                            {{ t('places-details-block') }}
                        </button>
                        <button
                            :disabled="loading"
                            v-if="!active"
                            class="btn btn-warning"
                            @click="activate()"
                        >
                            {{ t('places-details-activate') }}
                        </button>
                        <button
                            :disabled="loading"
                            class="btn"
                            :class="`${!automationsLocked ? 'btn-danger' : 'btn-primary'}`"
                            @click="changeAutomationsLock()"
                        >
                            {{ !automationsLocked ? t('places-details-deactivate_automations') : t('places-details-activate_automations') }}
                        </button>
                    </div>
                </div>
                <users-list />
                <branches-list />
                <plugins-list />
                <roles-list />
                <products-list v-if="user.global_admin" />
                <modules-list v-if="user.global_admin" />
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .title {
        display: flex;
        align-items: center;
        h1 {
            margin-left: 20px;
            margin-top: 0;
            margin-bottom: 0;
            line-height: 1em;
        }
    }
}
.box {
    margin: 30px 0;
}

form {
    .field {
        margin-top: 20px;
    }
    .permission-options {
        padding-left: 20px;
    }
}
</style>
<script>
import { mapState } from "vuex";
import UsersList from "./details/users/list";
import BranchesList from "./details/branches/list";
import RolesList from "./details/roles/list";
import ModulesList from "./details/modules/list";
import ProductsList from "./details/products/list";
import PluginsList from "./details/plugins/list";
import keviApi from "../keviApi";
require("./details.store");
export default {
    props: {
        user: Object,
    },
    components: {
        UsersList,
        BranchesList,
        RolesList,
        ModulesList,
        ProductsList,
        PluginsList
    },
    data: function () {
        return {
            loading: false,
            state: "ready",
        };
    },
    created: function () {
        this.setState("loading");
        this.$store
            .dispatch("placeDetails/setPlace", this.$route.params.id)
            .then(() => this.setState("ready"));
    },
    computed: mapState({
        id: (state) => state.placeDetails.id,
        logo: (state) => state.placeDetails.placeDetails.logo,
        name: (state) => state.placeDetails.placeDetails.name,
        roles: (state) => state.placeDetails.roles,
        active: (state) => state.placeDetails.placeDetails.active,
        automationsLocked: (state) => state.placeDetails.placeDetails.automations_locked,
    }),
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        changeAutomationsLock(){
            this.loading = true;
            this.$http(
                keviApi.getOptions("/place/" + this.id + "/automations-lock", "POST"),
            ).then(async (response) => {
                const message = this.automationsLocked ? this.t('places-details-automations_on') : this.t('places-details-automations_off')
                await this.$store.dispatch(
                    "placeDetails/loadInfo",
                    this.$route.params.id,
                );
                await this.$store.dispatch(
                    "notification/success",
                    this.t('places-details-automations_locked', { status: message }),
                );
                this.loading = false;
            });
        },
        logAsPlace: function () {
            this.$store.dispatch("changePlace", this.id);
        },
        block() {
            this.loading = true;
            this.$http(
                keviApi.getOptions("/place/" + this.id + "/block", "POST"),
            ).then(async (response) => {
                await this.$store.dispatch(
                    "placeDetails/loadInfo",
                    this.$route.params.id,
                );
                await this.$store.dispatch(
                    "notification/success",
                    this.t('places-details-place_blocked'),
                );
                this.loading = false;
            });
        },
        activate() {
            this.loading = true;
            this.$http(
                keviApi.getOptions("/place/" + this.id + "/activate", "POST"),
            ).then(async (response) => {
                await this.$store.dispatch(
                    "placeDetails/loadInfo",
                    this.$route.params.id,
                );
                await this.$store.dispatch(
                    "notification/success",
                    this.t('places-details-place_activated'),
                );
                this.loading = false;
            });
        },
        setState: function (state) {
            this.state = state;
        },
        is: function (state) {
            return state === this.state;
        },
    },
};
</script>
